/**
 * Asynchronously loads the component for EkycRedirectPage
 */

import loadable from 'utils/loadable';

export default loadable(() => import('./index'));